import { FC } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line no-restricted-imports
import { Trans as I18nTrans, TransProps } from 'react-i18next';

const Underline = styled.span`
    text-decoration: underline;
`;

const DEFAULT_COMPONENTS = {
    strong: <strong />,
    b: <b />,
    em: <em />,
    i: <i />,
    u: <Underline />,
    br: <br />,

    // Not standard HTML tags, but included for convenience
    bold: <strong />,
    underline: <Underline />,
    italic: <em />,
};

export const Trans: FC<TransProps<string>> = ({ components, ...props }) => (
    <I18nTrans {...props} components={{ ...DEFAULT_COMPONENTS, ...components }} />
);
